import {TitleBar} from "@shopify/app-bridge-react";
import {default as CldCon} from "./CloudianryConnect"
import {default as Sync} from "./SyncPage"

export default function Home(props) {
    const {backendUrl} = props
    if (document.location.pathname === "/") {
        if (window.top === window.self) {
            window.location.assign(`${backendUrl}/auth${window.location.search}`);
        }
    }
    const {shop} = props
    return(
        <>
            <CldCon shop={shop}/>
            <Sync/>
            <TitleBar title="Home"/>
        </>
    )
}